import { FlexContainer } from '@/ui/styled-ui';
import { Tooltip } from 'primereact/tooltip';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledLegendContainer = styled(FlexContainer)<{
  isMainDashboard?: boolean;
}>`
  > div {
    display: flex;
    gap: var(--xxsmall-padding);
    font-size: ${({ isMainDashboard }) =>
      isMainDashboard ? 'var(--xsmall-font-size)' : 'var(--small-font-size)'};
    user-select: none;
  }
`;

const StyledDot = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: relative;

  &.purple {
    background-color: var(--purple-text);
  }
  &.purple-light {
    background-color: var(--purple-text);
    opacity: 0.4;
  }

  &.purple {
    background-color: var(--purple-text);
  }

  &.purple-light {
    background-color: var(--purple-text);
    opacity: 0.4;
  }
`;

type SCLegendProps = {
  isMainDashboard?: boolean;
  hideOtherOrganisations?: boolean;
};

export const SCLegend: React.FC<SCLegendProps> = ({
  isMainDashboard,
  hideOtherOrganisations,
}) => {
  const { t } = useTranslation();
  return (
    <StyledLegendContainer
      isMainDashboard={isMainDashboard}
      justify="flex-start"
      gap={18}
    >
      <div id="legend-target-group">
        <StyledDot className="purple" />
        <span>{t('security.culture.target.group')}</span>
      </div>
      <Tooltip
        target="#legend-target-group"
        position="bottom"
        content={t('security.culture.target.group.tooltip')}
      />
      {!hideOtherOrganisations && (
        <>
          <div id="legend-other-organisation">
            <StyledDot className="purple-light" />
            <span>{t('security.culture.other.organisations')}</span>
          </div>
          <Tooltip
            target="#legend-other-organisation"
            position="bottom"
            content={t('security.culture.other.organisations.tooltip')}
          />
        </>
      )}
    </StyledLegendContainer>
  );
};
